import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import ArticleCard from "@/components/base/ArticleCard";
import { articles } from "@/mocks/news";

const picks = articles.filter((article) => !article.featured).slice(0, 3);
const ranking = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 8);

export default function SpotlightSection() {
  return (
    <section className="mx-auto max-w-content px-4 pt-16 md:px-6 md:pt-20">
      <SectionHeading
        eyebrow="Editor's pick"
        title="编辑精选与今日热榜"
        description="精选是我们认为值得慢读的观察稿，热榜则是此刻大家讨论最多的内容。"
      />

      <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <div className="space-y-4">
            {picks.map((article) => (
              <ArticleCard key={article.id} article={article} variant="horizontal" />
            ))}
          </div>
          <div className="mt-6 rounded-lg border border-accent-200 bg-accent-50 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-accent-900">
              <i className="ri-compass-3-line" aria-hidden="true" />
              新读者从这里开始
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-accent-800">
              如果你第一次来，建议先读那篇讲「艺人公关如何度过危机 48 小时」的稿子。它不涉及具体八卦，但能解释很多热搜为什么会变成现在这样。
            </p>
            <Link
              to="/article/crisis-pr-first-48-hours"
              className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-accent-800 transition-colors hover:text-accent-600"
            >
              阅读这篇文章
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </div>

        <aside className="lg:col-span-5" aria-label="今日热榜">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex items-center justify-between border-b border-background-300 pb-4">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
                吃瓜热榜
              </h3>
              <span className="text-xs text-foreground-500">按讨论热度排序</span>
            </div>
            <ol className="mt-2 divide-y divide-background-300">
              {ranking.map((article, index) => (
                <li key={article.id}>
                  <Link
                    to={`/article/${article.id}`}
                    title={`${article.title} - 美日吃瓜`}
                    className="group flex items-start gap-3 py-3"
                  >
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                        index < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-300 text-foreground-700"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm font-medium leading-relaxed text-foreground-800 transition-colors group-hover:text-primary-700">
                        {article.title}
                      </span>
                      <span className="mt-1 block text-xs text-foreground-500">
                        {article.categoryName} · 热度 {article.heat}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
            <Link
              to="/category/idol-meltdown"
              className="mt-4 inline-flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看更多频道内容
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}